
import { State } from 'vuex-class';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { FilterItem } from './FilterModel';

@Component({})
export default class TextFilter extends Vue {
    @Prop({ default: [] })
    values: FilterItem[];
    @Prop({ default: '' })
    label: string;
    @Prop({ default: [] })
    options: FilterItem[];

    private checkboxOptions: { label: string; value: string; selected: boolean }[] = [];

    created() {
        this.options.forEach(option => {
            this.checkboxOptions.push({
                label: option.label,
                value: option.value,
                selected: this.values && this.values.some(item => item.value === option.value)
            });
        });
    }

    @Watch('values', { deep: true })
    private onValuesChanged(newValues: FilterItem[]) {
        this.checkboxOptions.forEach(option => {
            option.selected = newValues && newValues.some(item => item.value === option.value);
        });
    }

    @Watch('checkboxOptions', { deep: true })
    private handleCheckboxChange(checkboxOptions: { label: string; value: string; selected: boolean }[]) {
        this.$emit(
            'update',
            checkboxOptions.filter(option => option.selected).map(option => new FilterItem(option.label, option.value))
        );
    }
}
